import { render, staticRenderFns } from "./CommandForm.vue?vue&type=template&id=51f4bcf8"
import script from "./CommandForm.vue?vue&type=script&lang=js"
export * from "./CommandForm.vue?vue&type=script&lang=js"
import style0 from "./CommandForm.vue?vue&type=style&index=0&id=51f4bcf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports